import React from "react";
import { useNavigate } from "react-router-dom";
import BaseAgentTable from "@/components/agent/BaseAgentTable";
import { routes } from "@/configs/router.config/routes";
import { useSubAgentMutations } from "@/hooks/agent/useSubAgentMutations";
import { useSubAgents } from "@/hooks/agent/useSubAgents";
import { useWorkspaces } from "@/hooks/useWorkspaces";

const SubAgentsTable: React.FC = () => {
  const navigate = useNavigate();
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { deleteSubAgent } = useSubAgentMutations();

  // enabled=false も含めて全て取得
  const { subAgents, isLoading, mutate } = useSubAgents(sessionCurrentWorkspaceId || null, false);

  const handleDelete = async (itemId: string, itemName: string) => {
    await deleteSubAgent(itemId, itemName);
    mutate();
  };

  return (
    <BaseAgentTable
      items={subAgents}
      loading={isLoading}
      onEdit={(subAgentId) => navigate(routes.editSubAgent(sessionCurrentWorkspaceId)(subAgentId))}
      handleDelete={handleDelete}
    />
  );
};

export default SubAgentsTable;
